import { Link } from 'react-router-dom'

export function Welcome() {
  return (
    <div className="page" style={{ paddingTop: 'var(--space-7)', minHeight: '100dvh' }}>
      <div className="stack" style={{ textAlign: 'center', gap: 'var(--space-2)' }}>
        <div style={{ fontSize: '3rem', lineHeight: 1 }} aria-hidden="true">
          🏡
        </div>
        <h1 className="title" style={{ fontSize: '1.9rem' }}>
          Brighton
        </h1>
        <p className="subtitle">
          Chores, plans and time together — so the whole house is working from the same page.
        </p>
      </div>

      <div className="stack" style={{ marginTop: 'var(--space-5)' }}>
        <Link to="/signup" className="btn btn-primary btn-block btn-lg">
          Set up our household
        </Link>
        <Link to="/signin" className="btn btn-ghost btn-block btn-lg">
          Sign in
        </Link>
        <Link to="/join" className="btn btn-quiet btn-block">
          I'm a parent with an invite code
        </Link>
      </div>

      <p className="faint" style={{ textAlign: 'center', marginTop: 'var(--space-4)' }}>
        One parent sets the household up and invites the other parent with a code. Kids sign in with a
        username and password a parent gives them — no email needed.
      </p>
    </div>
  )
}
